module.exports = __webpack_public_path__ + "sidebar-image.b3257e2a88ebaa3c1112.jpg";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/accessibility/layout/images/dashboard/sidebar-image.jpg
// module id = ../../../../../src/assets/accessibility/layout/images/dashboard/sidebar-image.jpg
// module chunks = styles